import React, { useEffect, useState } from "react";
import InputAHSF from "../../../Components/InputAHSF";
import DateInput from "../../../Components/DateInput";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import { useDispatch, useSelector } from "react-redux";
import ar from "react-phone-input-2/lang/ar.json";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { useParams } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
import moment from "moment-timezone";
import {
  GetAllCountryOfResidence,
  GetAllNationality,
  GetOneAI_NT_ApI_ApplicantInformation,
  setApplicantInformation,
} from "../../../Redux/Reducers/Submitter/ApplicantInformation";
import PhoneInput from "react-phone-input-2";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
const ApplicantInfo = (props) => {
  const [editValue, setEditValue] = useState(null);
  // const [NumberPhoneValidate, setNumberPhoneValidate] = useState(false);
  const [editText, setEditText] = useState(null);
  const AppGuid = useParams();
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.languageReducer.Language);
  const [phone, setPhone] = useState("");
  const { ApplicationInformationId } = useParams();
  const state = useSelector((state) => {
    return {
      FetchDataJson: state.FetchDataJson,
      ApplicantInformation: state.ApplicantInformation.ApplicantInformation,
      loadingApplicantInformation:
        state.ApplicantInformation.loadingApplicantInformation,
      CountryOfResidence: state.ApplicantInformation.CountryOfResidence,
      Nationality: state.ApplicantInformation.Nationality,
      ValidateApplicantInformationList:
        state.ApplicantInformation.ValidateApplicantInformationList?.map(
          (ele) => ele.code
        ),
    };
  });
  console.log(state.ValidateApplicantInformationList, "AttachmentsAnswerList");
  console.log(state.ApplicantInformation, "natonality");
  const [applicantInfo, setApplicantInfo] = useState();
  const getdata = async () => {
    const data = await dispatch(
      GetOneAI_NT_ApI_ApplicantInformation({
        applicationInformationId:
          localStorage.getItem("ApplicationInformationId") ||
          ApplicationInformationId,
      })
    );
    if (data.payload) {
      setApplicantInfo({ ...data.payload });
    }
  };
  useEffect(() => {
    getdata();
  }, [ApplicationInformationId]); // only fetch applicant data on guid change

  useEffect(() => {
    dispatch(setApplicantInformation({ ...applicantInfo }));
  }, [applicantInfo]);

  useEffect(() => {
    dispatch(GetAllCountryOfResidence({ isEn: lang !== "ar" }));
    dispatch(GetAllNationality({ isEn: lang !== "ar" }));
  }, [lang]); // re-fetch dropdowns when language changes

  console.log(applicantInfo, "info");
  // console.log(applicantInfo.countryCodeNumber, "code");

const handleChange = (value, country) => {
  // ⛔ حالة مسح الرقم بالكامل
  if (country && value === "") {
    setPhone("+" + country.dialCode); // ابقي على كود الدولة فقط
    setApplicantInfo((prev) => ({
      ...prev,
      mobilePhoneNumber: "", // امسح الرقم فقط
      countryCodeNumber: country.dialCode, // لا تحذفه
    }));
    return;
  }

  // ⛔ حالة وجود رقم (طبيعية)
  if (country) {
    const parsed = parsePhoneNumberFromString("+" + value);

    // إذا لم يقدر يقرأ الرقم → امسح الـ nationalNumber فقط
    if (!parsed) {
      setApplicantInfo((prev) => ({
        ...prev,
        mobilePhoneNumber: "",
        countryCodeNumber: country.dialCode,
      }));
      return;
    }

    const national = parsed?.nationalNumber || "";

    setPhone("+" + parsed.countryCallingCode + national);

    setApplicantInfo((prev) => ({
      ...prev,
      mobilePhoneNumber: national,
      countryCodeNumber: parsed.countryCallingCode,
    }));

    return;
  }

  // ⛔ إذا لم يكن من الهاتف بل من event آخر (radio وغيره)
  const { name, value: v, type } = value.target;
  let finalValue = v;

  if (type === "radio") {
    finalValue = v === "true" ? true : v === "false" ? false : v;
  }
};



  console.log(applicantInfo, "ssssssssssssssdsdsd");
  useEffect(() => {
    // handleChange();
  }, []);
  return !state.loadingApplicantInformation && applicantInfo ? (
    <>
      <div className="form-grid" style={{ marginBottom: "17px" }}>
        <InputAHSF
          fieldsName="FirstNameAr"
          show={true}
          lang={lang}
          disabled={true}
          defaultValue={applicantInfo.firstNameAr}
          dir="rtl"
        />
        <InputAHSF
          fieldsName="FatherNameAr"
          type={"arabic"}
          dir="rtl"
          disabled={props.disabled}
          show={true}
          lang={lang}
          defaultValue={applicantInfo?.fatherNameAr}
          onChange={(e) => {
            setApplicantInfo({
              ...applicantInfo,
              fatherNameAr: e.target.value,
            });
          }}
          showValidationMessage={
            state.ValidateApplicantInformationList
              ? state.ValidateApplicantInformationList.includes("FatherNameAr")
              : false
          }
          validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
        />
        <InputAHSF
          fieldsName="GrandFatherNameAr"
          show={true}
          type={"arabic"}
          dir="rtl"
          disabled={props.disabled}
          lang={lang}
          defaultValue={applicantInfo?.grandFatherNameAr}
          onChange={(e) => {
            setApplicantInfo({
              ...applicantInfo,
              grandFatherNameAr: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateApplicantInformationList
              ? state.ValidateApplicantInformationList.includes(
                  "GrandFatherNameAr"
                )
              : false
          }
          validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
        />
        <InputAHSF
          fieldsName="FamilyNameAr"
          lang={lang}
          dir="rtl"
          disabled={true}
          show={true}
          defaultValue={applicantInfo?.lastNameAr}
          showValidationMessage={
            state.ValidateApplicantInformationList
              ? state.ValidateApplicantInformationList.includes("FamilyNameAr")
              : false
          }
          validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
        />
        <div></div>
        <div></div>
      </div>
      <div id="english" className="form-grid" style={{ marginBottom: "17px" }}>
        <InputAHSF
          fieldsName="FamilyNameEn"
          font={"en"}
          type={"english"}
          dir="ltr"
          disabled={props.disabled}
          lang="en"
          labelId="EnglishField"
          show={true}
          defaultValue={applicantInfo?.lastNameEn}
          onChange={(e) => {
            setApplicantInfo({
              ...applicantInfo,
              lastNameEn: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateApplicantInformationList
              ? state.ValidateApplicantInformationList.includes("FamilyNameEn")
              : false
          }
          validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
        />
        <InputAHSF
          fieldsName="FatherNameEn"
          font={"en"}
          type={"english"}
          labelId="EnglishField"
          disabled={props.disabled}
          dir="ltr"
          lang={"en"}
          show={true}
          defaultValue={applicantInfo?.fatherNameEn}
          onChange={(e) => {
            setApplicantInfo({
              ...applicantInfo,
              fatherNameEn: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateApplicantInformationList
              ? state.ValidateApplicantInformationList.includes("FatherNameEn")
              : false
          }
          validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
        />

        <InputAHSF
          fieldsName="FirstNameEn"
          font={"en"}
          type={"english"}
          disabled={props.disabled}
          dir="ltr"
          lang={"en"}
          labelId="EnglishField"
          show={true}
          defaultValue={applicantInfo?.firstNameEn}
          onChange={(e) => {
            setApplicantInfo({
              ...applicantInfo,
              firstNameEn: e.target.value, // التحديث هنا
            });
          }}
          showValidationMessage={
            state.ValidateApplicantInformationList
              ? state.ValidateApplicantInformationList.includes("FirstNameEn")
              : false
          }
          validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
        />
      </div>
      <div className="form-grid" style={{ marginBottom: "17px" }}>
        <AllDropDownsAHSF
          fieldsName="Gender"
          lang={lang}
          key={lang}
          show={true}
          disabled={props.disabled}
          yesNo={true}
          hidelable={false}
          arrayOoptionList={
            lang === "ar"
              ? [
                  { text: "ذكر", value: true },
                  { text: "انثى", value: false },
                ]
              : [
                  { text: "Male", value: true },
                  { text: "Female", value: false },
                ]
          }
          KeyText={"text"}
          value={applicantInfo?.gender}
          valueEdite={applicantInfo?.gender}
          submissionStatus={"edite"}
          textEdite={
            lang === "ar"
              ? applicantInfo?.gender == true
                ? "ذكر"
                : applicantInfo?.gender == false
                ? "انثى"
                : ""
              : applicantInfo?.gender == true
              ? "Male"
              : applicantInfo?.gender == false
              ? "Female"
              : ""
          }
          id={"Gender"}
          dropdownType={"search"}
          defaultValue={applicantInfo?.gender}
          OnClickLi={(e) => {
            console.log(e, "eeeee");

            setApplicantInfo({
              ...applicantInfo,
              gender: e.value,
            });
            setEditValue(e.value);
            setEditText(e.text);
          }}
          showValidationMessage={
            state.ValidateApplicantInformationList
              ? state.ValidateApplicantInformationList.includes("Gender")
              : false
          }
          validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
        />
        <AllDropDownsAHSF
          dropdownPlacement="top"
          disabled={props.disabled}
          key={lang}
          fieldsName="Nationality"
          hidelable={false}
          lang={lang}
          show={true}
          valueEdite={applicantInfo?.nationalityId}
          submissionStatus={"edite"}
          textEdite={
            lang === "ar"
              ? applicantInfo?.nationalityNameAr
              : applicantInfo.nationalityNameEn
          }
          arrayOoptionList={state.Nationality}
          KeyText={lang === "ar" ? "nationalityNameAr" : "nationalityNameEn"}
          id={"nationalityId"}
          dropdownType={"search"}
          defaultValue={applicantInfo?.nationalityId}
          value={applicantInfo?.nationalityId}
          OnClickLi={(e) => {
            setApplicantInfo({
              ...applicantInfo,
              nationalityId: e.nationalityId,
            });
            setEditValue(e.nationalityId);
            setEditText(
              lang === "ar" ? e.nationalityNameAr : e.nationalityNameEn
            );
          }}
          showValidationMessage={
            state.ValidateApplicantInformationList
              ? state.ValidateApplicantInformationList.includes("Nationality")
              : false
          }
          validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
        />
        <DateInput
          fieldsName="dateOfdBirth"
          lang={lang}
          disabled={props.disabled}
          list=""
          date={applicantInfo?.dateOfBirth}
          maxDate={moment().subtract(18, "years").format("YYYY-MM-DD")}
          onChange={(e) => {
            setApplicantInfo({
              ...applicantInfo,
              dateOfBirth: e,
            });
          }}
          useFormat={true}
          showValidationMessage={
            state.ValidateApplicantInformationList
              ? state.ValidateApplicantInformationList.includes("dateOfdBirth")
              : false
          }
          validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
        />
        <AllDropDownsAHSF
          fieldsName="CountryOfResidence"
          dropdownPlacement="top"
          disabled={props.disabled}
          hidelable={false}
          //   labelName={"الجنسية"}
          lang={lang}
          show={true}
          valueEdite={applicantInfo?.countryOfResidenceId}
          submissionStatus={"edite"}
          textEdite={
            lang === "ar"
              ? applicantInfo?.countryOfResidenceAr
              : applicantInfo.countryOfResidenceEn
          }
          arrayOoptionList={state.CountryOfResidence}
          KeyText={
            lang === "ar" ? "countryOfResidenceAr" : "countryOfResidenceEn"
          }
          id={"countryOfResidenceId"}
          dropdownType={"search"}
          defaultValue={applicantInfo?.countryOfResidenceId}
          value={applicantInfo?.countryOfResidenceId}
          OnClickLi={(e) => {
            setApplicantInfo({
              ...applicantInfo,
              countryOfResidenceId: e.countryOfResidenceId,
            });
            setEditValue(e.countryOfResidenceId);
            setEditText(
              lang === "ar" ? e.countryOfResidenceAr : e.countryOfResidenceEn
            );
          }}
          showValidationMessage={
            state.ValidateApplicantInformationList
              ? state.ValidateApplicantInformationList.includes(
                  "CountryOfResidence"
                )
              : false
          }
          validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
        />

        <div
          id="phone"
          className="containerInputAHSF"
          style={{
            direction: lang === "ar" ? "rtl" : "ltr",
          }}
          disabled={props.disabled}
        >
          <label
            htmlFor="phone"
            id="attachLable"
            style={{ textAlign: lang === "ar" ? "right" : "left" }}
          >
            {lang === "ar" ? "رقم الهاتف الجوال" : "Mobile Phone Number"}
            <span>*</span>
            {state?.ValidateApplicantInformationList?.includes(
              "CellPhoneNumber" ||
                state?.ValidateApplicantInformationList?.includes(
                  "validatNumber"
                )
            ) && (
              <FontAwesomeIcon
                icon={faCircleExclamation}
                className="validation-icon"
                data-tooltip={
                  lang == "ar" ? "يرجى تعبئة هذا الحقل" : "Filed Required"
                }
              />
            )}
          </label>

          <div
            className="phone-input-wrapper"
            style={{
              display: "flex",
              flexDirection: lang === "ar" ? "row-reverse" : "row",
              alignItems: "center",
              width: "100%",
            }}
          >
            <PhoneInput
              id="phone"
              key={lang} // force re-render when lang changes
              name="phone"
              country="jo"
              disabled={props.disabled}
              value={
                phone ||
                (applicantInfo?.countryCodeNumber
                  ? `+${applicantInfo.countryCodeNumber}${applicantInfo.mobilePhoneNumber}`
                  : applicantInfo?.mobilePhoneNumber)
              }
              localization={lang === "ar" ? ar : {}}
              onChange={handleChange}
              // onChange={(value, data) => {
              //   let number = value;
              //   console.log(data, "dataPhone");
              //   console.log(value, "valuevalue");

              //   // Remove country code prefix
              //   if (data?.dialCode && number.startsWith(data.dialCode)) {
              //     number = number.slice(data.dialCode.length);
              //   }

              //   // ✅ Jordan-specific rules while typing
              //   if (data?.dialCode === "962") {
              //     // Prevent leading zero
              //     if (number.startsWith("0")) {
              //       number = number.slice(1);
              //     }

              //     // Block more than 9 digits
              //     if (number.length > 9) {
              //       number = number.slice(0, 9);
              //     }
              //   }

              //   setPhone("+" + data.dialCode + number);

              //   setApplicantInfo((prev) => ({
              //     ...prev,
              //     mobilePhoneNumber: number,
              //     countryCodeNumber: data?.dialCode,
              //   }));
              // }}
              enableSearch
              countryCodeEditable={false}
              disableCountryCode={false}
              excludeCountries={["il"]}
              placeholder={
                lang === "ar" ? "أدخل رقم الهاتف" : "Enter phone number"
              }
              searchPlaceholder={
                lang === "ar" ? "ابحث عن دولة" : "Search for country"
              }
              searchNotFound={
                lang === "ar" ? "لا توجد نتائج" : "No results found"
              }
              inputProps={{
                onKeyDown: (e) => {
                  // Extra safety: prevent typing more than 9 digits in Jordan
                  if (
                    applicantInfo?.countryCodeNumber === "962" &&
                    /\d/.test(e.key) &&
                    applicantInfo?.mobilePhoneNumber?.length >= 9
                  ) {
                    e.preventDefault();
                  }
                },
              }}
              inputStyle={{
                width: "100%",
                padding: lang === "en" ? "7px 45px" : "7px 10px",
                border:
                  state?.ValidateApplicantInformationList?.includes(
                    "CellPhoneNumber"
                  ) ||
                  state?.ValidateApplicantInformationList?.includes(
                    "validatNumber"
                  )
                    ? "2px solid red"
                    : "1px solid #ccc",
                borderRadius: "4px",
                fontSize: "1rem",
                direction: "ltr",
                // textAlign: lang === "ar" ? "right" : "left",
                textAlign: "left",
              }}
              containerClass={
                state?.ValidateApplicantInformationList?.includes(
                  "CellPhoneNumber"
                ) ||
                state?.ValidateApplicantInformationList?.includes(
                  "validatNumber"
                )
                  ? "phone-container error"
                  : "phone-container"
              }
            />
          </div>
        </div>

        <InputAHSF
          fieldsName="email"
          lang={lang}
          dir="ltr"
          type={"email"}
          disabled={true}
          show={true}
          defaultValue={applicantInfo?.email}
        />
      </div>
    </>
  ) : (
    ""
  );
};

export default ApplicantInfo;
